import { gql } from "@apollo/client";

// 로그인
export const LOGIN_MUTATION = gql`
  mutation login($userId: String!, $password: String!) {
    login(userId: $userId, password: $password) {
      ok
      token
      error
    }
  }
`;

// 유저 관리
export const USER_LIST_QUERY = gql`
  query listUser($type: String!, $skip: Int, $take: Int) {
    listUser(type: $type, skip: $skip, take: $take) {
      users {
        code
        userId
        userType
        userName
        sex
        phone
        residentNumber
        createdAt
        caregiverInfo {
          userCode
          address
          addressDetail
          residentNumber
          idCard
          bankInfo
          smoke
          drink
          mealCare
          urineCare
          suctionCare
          moveCare
          bedCare
        }
      }
      count
    }
  }
`;

export const USER_DETAIL_QUERY = gql`
  query viewProfile($code: Int!) {
    viewProfile(code: $code) {
      code
      userId
      userType
      userName
      sex
      phone
      residentNumber
      createdAt
      caregiverInfo {
        userCode
        address
        addressDetail
        residentNumber
        idCard
        bankInfo
        smoke
        drink
        career
        mealCare
        urineCare
        suctionCare
        moveCare
        bedCare
        introduce
      }
    }
  }
`;

export const USER_DELETE_MUTATION = gql`
  mutation deleteAccount($code: Int!) {
    deleteAccount(code: $code) {
      ok
    }
  }
`;

export const USER_CREATE_MUTATION = gql`
  mutation createAccount(
    $userId: String!
    $userType: String!
    $userName: String!
    $password: String!
    $sex: String
    $phone: String!
    $createdAt: String
    $address: String
    $addressDetail: String
    $residentNumber: String
    $smoke: String
    $drink: String
    $career: String
    $mealCare: String
    $urineCare: String
    $suctionCare: String
    $moveCare: String
    $bedCare: String
    $introduce: String
  ) {
    createAccount(
      userId: $userId
      userType: $userType
      userName: $userName
      password: $password
      sex: $sex
      phone: $phone
      createdAt: $createdAt
      address: $address
      addressDetail: $addressDetail
      residentNumber: $residentNumber
      smoke: $smoke
      drink: $drink
      career: $career
      mealCare: $mealCare
      urineCare: $urineCare
      suctionCare: $suctionCare
      moveCare: $moveCare
      bedCare: $bedCare
      introduce: $introduce
    ) {
      ok
      error
    }
  }
`;

export const USER_EDIT_MUTATION = gql`
  mutation editAccount(
    $userCode: Int!
    $phone: String
    $userName: String
    $password: String
    $createdAt: String
    $residentNumber: String
  ) {
    editAccount(
      userCode: $userCode
      phone: $phone
      userName: $userName
      password: $password
      createdAt: $createdAt
      residentNumber: $residentNumber
    ) {
      ok
      error
    }
  }
`;

export const CAREGIVER_INFO_EDIT_MUTATION = gql`
  mutation editCaregiverInfo(
    $userCode: Int!
    $address: String
    $addressDetail: String
    $residentNumber: String
    $smoke: String
    $drink: String
    $career: String
    $mealCare: String
    $urineCare: String
    $suctionCare: String
    $moveCare: String
    $bedCare: String
    $introduce: String
  ) {
    editCaregiverInfo(
      userCode: $userCode
      address: $address
      addressDetail: $addressDetail
      residentNumber: $residentNumber
      smoke: $smoke
      drink: $drink
      career: $career
      mealCare: $mealCare
      urineCare: $urineCare
      suctionCare: $suctionCare
      moveCare: $moveCare
      bedCare: $bedCare
      introduce: $introduce
    ) {
      ok
      error
    }
  }
`;

// 공고 관리
export const ANNOUNCEMENT_LIST_QUERY = gql`
  query listAnnouncement($status: Int, $skip: Int!, $take: Int!) {
    listAnnouncement(status: $status, skip: $skip, take: $take) {
      announcements {
        code
        status
        userCode
        needMealCare
        needUrineCare
        needSuctionCare
        needMoveCare
        needBedCare
        needHygieneCare
        caregiverMeal
        infectiousDisease
        title
        startDate
        endDate
        protectorName
        protectorPhone
        patientName
        patientAge
        patientWeight
        address
        addressDetail
        branchCode
        codeBranch {
          code
          branchName
        }
        nursingGrade
        disease
        isolation
        createdAt
      }
      count
    }
  }
`;

export const ANNOUNCEMENT_DETAIL_QUERY = gql`
  query viewAnnouncement($code: Int!) {
    viewAnnouncement(code: $code) {
      code
      status
      userCode
      needMealCare
      needUrineCare
      needSuctionCare
      needMoveCare
      needBedCare
      needHygieneCare
      caregiverMeal
      infectiousDisease
      title
      startDate
      endDate
      expectedCost
      hopeCost
      confirmCost
      protectorName
      protectorPhone
      patientName
      patientAge
      patientWeight
      address
      addressDetail
      branchCode
      codeBranch {
        code
        branchName
      }
      nursingGrade
      disease
      isolation
      createdAt
      user {
        userId
        userName
        sex
        phone
      }
      announcementApplication {
        userCode
        caregiverCost
        confirm
        user {
          userId
          userName
          sex
          phone
        }
      }
    }
  }
`;

export const EXPECTEDCOST_WRITE_QUERY = gql`
  mutation writeExpectedCost($code: Int!, $expectedCost: Int!) {
    writeExpectedCost(code: $code, expectedCost: $expectedCost) {
      ok
      error
    }
  }
`;

export const COMPLETE_ANNOUNCEMENT_MUTATION = gql`
  mutation completeAnnouncement($code: Int!) {
    completeAnnouncement(code: $code) {
      ok
      error
    }
  }
`;

export const DELETE_ANNOUNCEMENT_MUTATION = gql`
  mutation deleteAnnouncement($announcementCode: Int!) {
    deleteAnnouncement(announcementCode: $announcementCode) {
      ok
      error
    }
  }
`;

export const CODE_BRANCH_LIST_QUERY = gql`
  query listCodeBranch {
    listCodeBranch {
      code
      branchName
    }
  }
`;

export const RESPONSIBLE_REGION_WRITE_MUTATION = gql`
  mutation writeResponsibleRegion($code: Int!, $branchCode: Int!) {
    writeResponsibleRegion(code: $code, branchCode: $branchCode) {
      ok
      error
    }
  }
`;

// 정산 관리
export const SETTLEMENT_LIST_QUERY = gql`
  query listSettlement($year: Int!, $month: Int!, $branchCode: Int) {
    listSettlement(year: $year, month: $month, branchCode: $branchCode) {
      items {
        code
        title
        patientName
        caregiverName
        caregiverPhone
        branchName
        confirmCost
        startDate
        endDate
        completedAt
      }
      count
      totalAmount
      result
      error
    }
  }
`;

// 공지사항 관리
export const NOTICE_LIST_QUERY = gql`
  query listNotice($category: String!, $skip: Int!, $take: Int!) {
    listNotice(category: $category, skip: $skip, take: $take) {
      notices {
        code
        title
        content
        createdAt
      }
      count
    }
  }
`;

export const NOTICE_DETAIL_QUERY = gql`
  query viewNotice($code: Int!) {
    viewNotice(code: $code) {
      code
      title
      content
      createdAt
    }
  }
`;

export const NOTICE_DELETE_MUTATION = gql`
  mutation deleteNotice($code: Int!) {
    deleteNotice(code: $code) {
      ok
    }
  }
`;

export const NOTICE_WRITE_MUTATION = gql`
  mutation writeNotice($category: String!, $title: String!, $content: String!) {
    writeNotice(category: $category, title: $title, content: $content) {
      ok
    }
  }
`;

export const NOTICE_EDIT_MUTATION = gql`
  mutation editNotice($code: Int!, $title: String!, $content: String!) {
    editNotice(code: $code, title: $title, content: $content) {
      ok
    }
  }
`;

// 병원 관리
export const HOSPITAL_LIST_QUERY = gql`
  query listHospital {
    listHospital {
      id
      logo
      name
      address
      phone
      tags
    }
  }
`;

export const HOSPITAL_DETAIL_QUERY = gql`
  query viewHospital($id: Int!) {
    viewHospital(id: $id) {
      id
      logo
      name
      address
      phone
      tags
      greeting
      images
      latitude
      longitude
    }
  }
`;

export const HOSPITAL_CREATE_MUTATION = gql`
  mutation createHospital(
    $name: String!
    $tags: String
    $greeting: String
    $address: String
    $phone: String
    $latitude: Float
    $longitude: Float
    $logo: Upload
    $images: [Upload]
  ) {
    createHospital(
      name: $name
      tags: $tags
      greeting: $greeting
      address: $address
      phone: $phone
      latitude: $latitude
      longitude: $longitude
      logo: $logo
      images: $images
    ) {
      ok
      id
      error
    }
  }
`;

export const HOSPITAL_EDIT_MUTATION = gql`
  mutation editHospital(
    $id: Int!
    $name: String
    $tags: String
    $greeting: String
    $address: String
    $phone: String
    $latitude: Float
    $longitude: Float
    $logo: Upload
    $newImages: [Upload]
    $keptImages: [String]
  ) {
    editHospital(
      id: $id
      name: $name
      tags: $tags
      greeting: $greeting
      address: $address
      phone: $phone
      latitude: $latitude
      longitude: $longitude
      logo: $logo
      newImages: $newImages
      keptImages: $keptImages
    ) {
      ok
      id
      error
    }
  }
`;

export const HOSPITAL_DELETE_MUTATION = gql`
  mutation deleteHospital($id: Int!) {
    deleteHospital(id: $id) {
      ok
      error
    }
  }
`;
